var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 45,
    viewBox: "0 0 34 45",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.8 40.875c-2.063-2.344-4.125-4.781-5.438-7.688C.05 30.095-.325 26.532.332 23.157c.655-3.376 2.155-6.563 4.312-9.282-.188 2.344.656 4.781 2.25 6.563-.938-4.5.562-9.375 3.562-12.938 3-3.562 7.125-5.906 11.438-7.5-2.157 2.25-2.438 5.812-1.594 8.813.844 3 2.625 5.625 4.219 8.343 1.593 2.719 3.093 5.531 3.187 8.625.844-1.593 1.781-3.187 2.344-4.968.562-1.782.844-3.657.375-5.438 1.687 2.063 2.625 4.125 3.094 6.75.468 2.625.375 5.344.093 7.969C33.237 33 32.487 36 30.894 38.437c-1.875 2.907-4.875 4.97-8.157 6.094-5.812 1.032-11.53.188-15.937-3.656z",
    fill: "#F3705A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.925 44.344c7.687 3 15.281-6.094 11.062-13.125 0-.094-.093-.094-.093-.188.375 3.844-.563 6.657-2.344 8.25.937-2.25.281-4.875-.844-7.125-1.125-2.156-2.719-4.125-3.938-6.187-1.218-2.156-2.156-4.594-1.593-7.031-2.25 1.687-3.844 4.218-4.5 6.937-.657 2.719-.281 5.719.937 8.25-1.406-1.031-2.437-2.719-2.53-4.5-1.501 1.781-2.438 4.125-2.345 6.469 0 3.656 2.907 6.937 6.188 8.25z",
    fill: "#FFD15C"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.fa3f1a9b647c34d1a536d7255f7640a9.svg";
export { ForwardRef as ReactComponent };